import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'gdp-user-password-form',
  templateUrl: './user-password-form.component.html',
  styleUrls: ['./user-password-form.component.scss']
})
export class UserPasswordFormComponent implements OnInit {
  @Output() onSubmit: EventEmitter<string> = new EventEmitter();
  @Input() loading: boolean;
  @Input() submitLabel: string;
  public form: UntypedFormGroup;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      newPassword: new UntypedFormControl('', Validators.required),
      confirmPassword: new UntypedFormControl('', Validators.required)
    }, this.passwordsMatchValidator);
  }

  get language() {
    return this.translate.currentLang;
  }

  get isConfirmationErrorVisible() {
    const value = this.form.value;
    const lengthMatch = value.confirmPassword.length === value.newPassword.length;
    return this.form.controls.confirmPassword.dirty && this.form.invalid && lengthMatch;
  }


  private passwordsMatchValidator(g: UntypedFormGroup) {
    return g.controls.newPassword.valid
      && g.value.newPassword === g.value.confirmPassword
      ? null
      : { noMatch: true }
  }

  submit() {
    this.onSubmit.emit(this.form.value.newPassword);
  }

}
